<template>
  <div id="menu">
    <div class="start" :class="{end : modalData}">
      <Modal @closeModal="modalData=false" :oneroom="oneroom" :clickData="clickData" :modalData="modalData" :close="close" :objectData="objectData"/>
    </div>
    <button @click="sorting">낮은가격순정렬</button>
    <button @click="sortBack">원래대로</button>
    <Card @openModal="modalData=true; clickData = $event" :oneroom="oneroom" :modalData="modalData" :close="close"/>
  </div>
</template>

<script>

import data from './assets/oneroom.js';
import Modal from './components/Modal.vue';
import Card from './components/Card.vue';

export default {
  data(){
    return {
      oneroomOrg : [...data],
      objectData : { name : 'kim', age: 20},
      oneroom : data,
      clickData : 0,
      modalData : false
    }
  },
  components: {
    Modal : Modal,
    Card : Card
  },
  methods : {
    close : function(){
      this.modalData = false;
    },
    sorting : function() {
      this.oneroom.sort(function(a,b){
        return a.price-b.price
      })
    },
    sortBack : function (){
      this.oneroom = [...this.oneroomOrg];
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin : 0;
}
div {
  box-sizing: border-box;
}
.black-bg {
  width: 100%; height:100%;
  background: rgba(0,0,0,0.5);
  position: fixed; padding: 20px;
}
.white-bg {
  width: 100%; background: white;
  border-radius: 8px;
  padding: 20px;
}
.start {
  opacity : 0;
  transition:all 1s;
} 
.end {
  opacity: 1;
}
</style>
